import { render } from "./CoursesRepartition.vue?vue&type=template&id=700bff3a&scoped=true"
import script from "./CoursesRepartition.vue?vue&type=script&lang=js"
export * from "./CoursesRepartition.vue?vue&type=script&lang=js"

import "./CoursesRepartition.vue?vue&type=style&index=0&id=700bff3a&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700bff3a"]])

export default __exports__